import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { JsonSQLite } from '@capacitor-community/sqlite';

@Injectable({
    providedIn: 'root',
})
export class SyncService
{
    private endPoint = '/sync';
    private http = inject(HttpClient);

    sync(data: JsonSQLite, isOverdue: boolean): Promise<{ status: boolean, message: string, }>
    {
        const neededTableNames = ['check_ins', 'cart_items', 'return_items', 'payments'];
        const tables = Array.isArray(data?.tables) ? data.tables : [];
        const filteredTables = tables
            .filter((t) =>
                neededTableNames.includes(t.name.toLowerCase()),
            )
            .map((t) =>
            {
                const schema = (t.schema || []).filter((c) => c.column !== null && c.column !== undefined);

                return {
                    name: t.name,
                    schema: schema.map((c) => ({ column: c.column, })),
                    values: t.values || [],
                };
            });
        const url = `${this.endPoint}/v2`;

        return firstValueFrom(this.http.post<{
            status: boolean, message: string,
        }>(url, { tables: filteredTables, is_overdue: isOverdue ? 1 : 0, }));
    }
}
